<template>
  <b-modal size="xl" ref="editGame">
    <TrackGameForm
      ref="editGameForm"
      :game="game"
      @updated="hide"
      @update:isValid="isValid = $event"
    />
    <template #modal-footer="{ cancel }">
      <b-button variant="primary" @click="update" :disabled="!isValid">
        Update
      </b-button>
      <b-button variant="outline-danger" @click="deleteGame"
        ><font-awesome-icon :icon="['fas', 'trash-alt']" /> Delete
      </b-button>
      <b-button @click="cancel()"> Cancel </b-button>
    </template>
  </b-modal>
</template>

<script>
import TrackGameForm from "@/components/TrackGameForm.vue";

import api from "@/api";

export default {
  name: "TrackGameModal",
  components: {
    TrackGameForm,
  },
  props: ["game"],
  data() {
    return {
      isValid: false,
    };
  },
  methods: {
    show() {
      this.$refs.editGame.show();
    },
    hide() {
      this.$refs.editGame.hide();
    },
    async update() {
      await this.$refs.editGameForm.updateGame();
      this.$emit("refresh");
    },
    async deleteGame() {
      try {
        await api.deleteGame(this.game.id);
        this.$root.$bvToast.toast("Your game has been deleted", {
          title: "Success",
          variant: "success",
        });
        this.$emit("refresh");
        this.hide();
      } catch (err) {
        this.$root.$bvToast.toast(err.response.statusText, {
          title: "Error deleting game",
          variant: "danger",
        });
      }
    },
  },
};
</script>
